import React, { useState, useEffect, useRef } from "react";
import { useSnackbar } from "notistack";
import "react-datepicker/dist/react-datepicker.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FileUploadAddLead from "../../lead/FileUploadAddLead";
import { uploadFile, getFilesByLead } from "../../../store/slices/FileDataSlice";
import { resolveCountryInputConfig, useCurrencySymbol } from "../../../utils/currencyUtils";
import DateConversion from "../../../utils/DateConversion";
import CommaConvert from "../../../utils/CommaConvert";
import { setcurrentLeadID, setCurrentPageTitle } from "../../../store/slices/pageSlice";
import { fetchLeads, updateLead } from "../../../store/slices/leadsSlice";
import { fetchGroups } from "../../../store/slices/groupSlice";
import { fetchStatus } from "../../../store/slices/statusSlice";
import { fetchSources } from "../../../store/slices/sourceSlice";
import { fetchLeadTypes } from "../../../store/slices/leadTypeSlice";
import { fetchServiceTypes } from "../../../store/slices/serviceTypesSlice";
import { fetchEmployees } from "../../../store/slices/employeeSlice";
import AdminLoader from "../../../components/common/loader/AdminLoader";
import { clearWizardState, goBack, goNext, resetStep, setCreatedProject, setExistingEditAdvancedProject, setOperationProjectStatus } from "../../../store/slices/WizardSlice/wizardStepSlice";
import { useLoggedUser } from "../../../utils/useLoggedUser";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { fetchSalesHourlyRates } from "../../../store/slices/salesHourlyRateSlice";
import { updateProjectQuotedStatusThunk } from "../../../store/slices/projectQuoteSlice";
import { buildProjectsDetailsPayloadForLeadEdit } from "../../../utils/buildProjectsDetailsForUpdateLockQuoted";
import { fetchOtherExpenses } from "../../../store/slices/otherexpenses";
import {
  getLoggedSalesUserId,
  getPerdiemAndAverageCostFromExpenses,
  scopeOtherExpensesForUser,
} from "../../../utils/salespersonRatesScope";
import { useNavigate } from "react-router-dom";
import useSubscriptionLevel from "../../../utils/SubscriptionLevel";
import useMatchedProject from "../OperationWizard/useMatchedProject";

const EditExistingProject = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate()
  const currency = useCurrencySymbol();
  const loggedUser = useLoggedUser();
  const subscriptionPackage = useSubscriptionLevel();
  const { getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();
  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const editProjectID = createdProject[0]?.id
  const operationProjectStatus = useSelector((state) => state.wizardstep.operationProjectStatus);
  const existingEditAdvancedProject = useSelector((state) => state.wizardstep.existingEditAdvancedProject);
  const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
  const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);
  const { leads } = useSelector((state) => state.leads);
  const { group } = useSelector((state) => state.group);
  const { status } = useSelector((state) => state.status);
  const { source } = useSelector((state) => state.source);
  const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
  const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
  const { projects } = useSelector((state) => state.projects);
  const { data: salesHourlyRateData } = useSelector((state) => state.salesHourlyRate);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);
  const email = localStorage.getItem("email");

  const step = useSelector((state) => state.wizardstep.step);

  const [quotationId, setQuotationId] = useState("");
  console.log("EditExistingProject createdProject", createdProject)

  useEffect(() => {
    dispatch(setCurrentPageTitle("Edit Project"));
    if (quotationId) {
      dispatch(setcurrentLeadID(quotationId));
    }
  }, [dispatch, quotationId]);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(fetchStatus());
    dispatch(fetchSources());
    dispatch(fetchLeadTypes());
    dispatch(fetchServiceTypes());
    dispatch(fetchEmployees());
    dispatch(fetchOtherExpenses());
    dispatch(fetchSalesHourlyRates());
  }, [dispatch]);

  const [ProjectName, setProjectName] = useState("");


  const [allowtoedit, setAllowtoedit] = useState([])

  useEffect(() => {
    if (ProjectName || projects?.length > 0) {
      const matchedProject = projects.filter(
        (proj) => proj.ProjectName === ProjectName
      );
      setAllowtoedit(matchedProject || []);
    }
  }, [projects, ProjectName]);

  const [LeadReports, setLeadReports] = useState([]);
  const [GroupNames, setGroupNames] = useState([]);
  const [LeadTypes, setLeadTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [Sources, setSources] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [AssignedGroup, setAssignedGroup] = useState("");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [LeadOwner, SetLeadOwner] = useState("");
  const [ClientName, setClientName] = useState("");
  const [LeadType, setLeadType] = useState("");
  const [QuotedValue, setQuotedValue] = useState("");
  const [LeadDate, setLeadDate] = useState("");
  const [ClientPhone, setClientPhone] = useState("");
  const [ClientContactName, setClientContactName] = useState("");
  const [Status, setStatus] = useState("");
  const [Source, setSource] = useState("");
  const [FollowupDate, setFollowupDate] = useState("");
  const [Probability, setProbability] = useState("");
  const [Reference, setReference] = useState("");
  const [ClientEmail, setClientEmail] = useState("");
  const [comments, setComments] = useState("");
  const [editingLeadReport, setEditingLeadReport] = useState(null);
  const [isLoading, SetisLoading] = useState(false);
  const [showSourceDropdown, setShowSourceDropdown] = useState("");
  const [showGroupDropdown, setShowGroupDropdown] = useState("");
  const [showServiceDropdown, setShowServiceDropdown] = useState("");
  const [showLeadTypeDropdown, setShowLeadTypeDropdown] = useState("");
  const [showStatusDropdown, setShowStatusDropdown] = useState("");
  const [showProbabilityDropdown, setShowProbabilityDropdown] = useState("");

  const [, setEmployeesfinalList] = useState([]);
  const [Category] = useState("");
  const [SelectedCategory, setSelectedCategory] = useState("");
  const [fileNames, setFileNames] = useState([]);
  const [editfetchedfiles, seteditFetchedFiles] = useState({ payload: [] });
  const employeeslist = useSelector((state) => state.employees.employees);
  const [TypeService, setSelectedServices] = useState([]);

  useEffect(() => {
    setLeadReports(leads);
    setGroupNames(group);
    setLeadTypes(leadTypesRedux);
    setStatuses(status);
    setSources(source);
  }, [leads, group, leadTypesRedux, status, source, serviceTypesRedux]);


  useEffect(() => {
    if (!AssignedGroup || !Array.isArray(group)) return;
    const matchedGroup = group.find(
      (g) => g.newGroupName === AssignedGroup
    );
    if (matchedGroup) {
      setServiceTypes(matchedGroup.servicetype || []);
    } else {
      setServiceTypes([]); // Reset if no match
    }
  }, [AssignedGroup, group]);

  useEffect(() => {
    if (AssignedGroup && !selectedGroupId) {
      const matched = (group || []).find((g) => g?.newGroupName === AssignedGroup);
      if (matched?._id || matched?.id) {
        setSelectedGroupId(matched?._id || matched?.id);
      }
    }
  }, [AssignedGroup, selectedGroupId, group]);

  useEffect(() => {
  }, [dispatch]);

  useEffect(() => {
    if (employeeslist) {
      setEmployeesfinalList(employeeslist);
    }
  }, [employeeslist]);

  const dropdownRefSource = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefSource.current &&
        !dropdownRefSource.current.contains(event.target)
      ) {
        setShowSourceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setShowGroupDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefService = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefService.current &&
        !dropdownRefService.current.contains(event.target)
      ) {
        setShowServiceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefLeadType = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefLeadType.current &&
        !dropdownRefLeadType.current.contains(event.target)
      ) {
        setShowLeadTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefStatus = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefStatus.current &&
        !dropdownRefStatus.current.contains(event.target)
      ) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefProbability = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefProbability.current &&
        !dropdownRefProbability.current.contains(event.target)
      ) {
        setShowProbabilityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSourceChange = (source) => {
    const value = source;
    setSource(value);
    setShowSourceDropdown(false);
  };

  const handleGroupChange = (Group) => {
    const value = Group;
    setAssignedGroup(value);
    const matched = (group || []).find((g) => g?.newGroupName === value);
    setSelectedGroupId(matched?._id || matched?.id || "");
    setShowGroupDropdown(false);
  };

  const handleServiceChange = (service) => {
    setSelectedServices((prevSelected) => {
      if (prevSelected.includes(service)) {
        return prevSelected.filter((s) => s !== service);
      } else {
        return [...prevSelected, service];
      }
    });
  };
  const handleLeadTypeChange = (Leadtype) => {
    const value = Leadtype;
    setLeadType(value);
    setShowLeadTypeDropdown(false);
  };

  const handleStatusChange = (status) => {
    const value = status;
    setStatus(value);
    setShowStatusDropdown(false);
    if (value !== "Pending") {
      setProbability("");
    }
  };

  const handleProbabilityChange = (Probability) => {
    const value = Probability;
    setProbability(value);
    setShowProbabilityDropdown(false);
  };


  useEffect(() => {
    if (LeadReports.length > 0) {
      const ReportToEdit = LeadReports.find(
        (LeadReport) => String(LeadReport.id) === String(editProjectID)
      );
      setEditingLeadReport(ReportToEdit || null);
    }
  }, [LeadReports, editProjectID]);

  useEffect(() => {
    if (editingLeadReport) {
      const editGroupId = editingLeadReport.groupid?._id || editingLeadReport.groupid || "";
      const editGroupName =
        group.find((g) => String(g?._id || g?.id) === String(editGroupId))?.newGroupName ||
        editingLeadReport.AssignedGroup ||
        "";
      SetLeadOwner(editingLeadReport.LeadOwner);
      setClientName(editingLeadReport.ClientName);
      setLeadDate(editingLeadReport.LeadDate);
      setSource(editingLeadReport.Source);
      setClientContactName(editingLeadReport.ClientContactName);
      setClientPhone(editingLeadReport.ClientPhone);
      setProjectName(editingLeadReport.ProjectName);
      setSelectedServices(editingLeadReport.TypeService);
      setQuotedValue(editingLeadReport.QuotedValue);
      setAssignedGroup(editGroupName);
      setSelectedGroupId(editGroupId ? String(editGroupId) : "");
      setLeadType(editingLeadReport.LeadType);
      setStatus(editingLeadReport.Status);
      setFollowupDate(editingLeadReport.FollowupDate);
      setClientEmail(editingLeadReport.ClientEmail);
      setReference(editingLeadReport.Reference);
      setComments(editingLeadReport.comments);
      setProbability(editingLeadReport.Probability);
      setSelectedCategory(editingLeadReport?.Category);
      setQuotationId(editingLeadReport?.quotationId);
    }
  }, [editingLeadReport, group]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const clearStateOnSubmit = () => {
    setClientName("");
    setLeadDate("");
    setClientPhone("");
    setClientContactName("");
    setStatus("");
    setProjectName("");
    setQuotedValue("");
    setSelectedServices("");
    setAssignedGroup("");
    setSelectedGroupId("");
    setLeadType("");
    setFollowupDate("");
    setProbability("");
    setClientEmail("");
    setSource("");
    setReference("");
    setComments("");
    setSelectedCategory("");
  }
  const operationProjectName = createdProject[0]?.ProjectName;
  const { SalesStatus } = useMatchedProject(operationProjectName);

  const Submit = async () => {

    if (
      !ClientName ||
      !LeadType ||
      (Status !== "Won" && Status !== "Lost" && !FollowupDate) ||
      (Status === "Pending" &&
        !["High", "Medium", "Low"].includes(Probability)) ||
      !LeadDate ||
      !Source ||
      !ClientPhone ||
      !ClientContactName ||
      !TypeService ||
      !Status ||
      !ProjectName ||
      !QuotedValue
    ) {
      enqueueSnackbar("Please fill all the fields!", { variant: "error" });
      return;
    }

    if (!emailRegex.test(ClientEmail)) {
      enqueueSnackbar("Please enter a valid email address!", {
        variant: "error",
      });
      return;
    }

    if (Status === "Pending" && !Probability) {
      enqueueSnackbar("Please provide Probability for Pending status!", {
        variant: "error",
      });
      return;
    }

    if (Source === "Reference" && !Reference) {
      enqueueSnackbar("Please enter Reference!", { variant: "error" });
      return;
    }

    SetisLoading(true);

    try {
      const updatedLeadData = {
        LeadOwner,
        ClientName,
        ProjectName,
        LeadDate,
        QuotedValue,
        Status,
        AssignedGroup,
        groupid: selectedGroupId || undefined,
        LeadType,
        FollowupDate,
        Probability: Status === "Pending" ? Probability : "",
        Source,
        Reference,
        TypeService,
        ClientContactName,
        ClientEmail,
        ClientPhone,
        comments,
        Category,
        quotationId,
      };
      const response = await dispatch(
        updateLead({ id: editingLeadReport.id, updatedData: updatedLeadData })
      ).unwrap();

      const isErpPackage = subscriptionPackage === "ERP";
      const prevStatusNorm = String(editingLeadReport?.Status ?? "").trim().toLowerCase();
      const nextStatusTrimmed = String(Status ?? "").trim();
      const shouldLockQuoted =
        isErpPackage &&
        prevStatusNorm === "pending" &&
        (nextStatusTrimmed === "Won" || nextStatusTrimmed === "Won Recurring") &&
        quotationId;

      if (shouldLockQuoted) {
        let expensesList = otherExpenses;
        if (!expensesList?.length) {
          try {
            expensesList = await dispatch(fetchOtherExpenses()).unwrap();
          } catch {
            expensesList = [];
          }
        }
        const salesUserId = getLoggedSalesUserId(
          loggedInUserId,
          employeeslist,
          email
        );
        const expensesForUser = scopeOtherExpensesForUser(expensesList, {
          loggedUserId: salesUserId,
        });
        const { perdiem, averagecost } =
          getPerdiemAndAverageCostFromExpenses(expensesForUser);
        let ratesList = salesHourlyRateData;
        if (!ratesList?.length) {
          try {
            ratesList = await dispatch(fetchSalesHourlyRates()).unwrap();
          } catch {
            ratesList = [];
          }
        }
        const projectsDetails = buildProjectsDetailsPayloadForLeadEdit(
          projects,
          ratesList,
          quotationId,
          ProjectName,
          { perdiem, avgcost: averagecost },
          salesUserId
        );
        if (projectsDetails.length > 0) {
          try {
            await dispatch(updateProjectQuotedStatusThunk(projectsDetails)).unwrap();
            await dispatch(fetchAllProjects());
          } catch (lockErr) {
            console.error("Failed to update project quoted status:", lockErr);
          }
        }
      }

      console.log("EditExistingProject response?.lead", response?.lead)
      dispatch(setCreatedProject([response?.lead]))
      dispatch(fetchAllProjects());
      dispatch(fetchLeads());
      enqueueSnackbar("Lead Updated Successfully!", { variant: "success" });
      clearStateOnSubmit();
      
      // Upload files if any were selected
      if (fileNames.length > 0 && response?.lead?._id) {
        await handleFileUpload(response.lead._id);
      }
      
      // In ERP module: If status is "Won" or "Won Recurring", immediately redirect to dashboard
      const currentStatus = Status?.toLowerCase()?.trim() || "";
      const isWon = currentStatus === "won" || currentStatus === "won recurring";
      
      if (subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" && isWon) {
        // Immediately clear wizard state and redirect to dashboard
        dispatch(clearWizardState());
        dispatch(setcurrentLeadID(""));
        navigate('/dashboard');
        return; // Exit early, don't call handleNext
      }
      
      handleNext(response?.lead);
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error?.error ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong!";
      enqueueSnackbar(errorMessage, { variant: "error" });
    } finally {
      setTimeout(() => {
        SetisLoading(false);
      }, 2000);
      // dispatch(setcurrentLeadID());
    }
  };

  // Fetch existing files when editingLeadReport is available
  useEffect(() => {
    if (!editingLeadReport?.id && !editProjectID) return;

    const loadFiles = async () => {
      try {
        const leadId = editingLeadReport?.id || editProjectID;
        const files = await dispatch(getFilesByLead(leadId)).unwrap();
        seteditFetchedFiles(Array.isArray(files) ? { payload: files } : files);
      } catch (err) {
        console.error("Error fetching files:", err);
      }
    };

    loadFiles();
  }, [editingLeadReport, editProjectID, dispatch]);


  const handleFileUpload = async (leadID) => {
    if (!fileNames.length) {
      return;
    }
    const uploadDate = new Date().toISOString().slice(0, 10); // "2024-07-11"
    const formData = new FormData();

    formData.append("leadId", leadID);
    formData.append("uploadDate", uploadDate);

    fileNames.forEach((file) => {
      formData.append("selectedCategory", file.selectedCategory);
      formData.append("files", file);
    });

    try {
      await dispatch(uploadFile(formData)).unwrap();
      enqueueSnackbar("Files uploaded successfully", { variant: "success" });
      // Refresh files list
      const files = await dispatch(getFilesByLead(leadID)).unwrap();
      seteditFetchedFiles(Array.isArray(files) ? { payload: files } : files);
      setFileNames([]); // Clear uploaded files
    } catch (error) {
      console.error("Error uploading files:", error);
      enqueueSnackbar("Error uploading files", { variant: "error" });
    }
  };
  //     // setFileUpload((prev) => prev + 1);
  //     // dispatch(fetchFilesByLeadId(id)); // Fetch updated files after upload
  //     fetchFiles();
  //   } catch (error) {
  //     enqueueSnackbar("Error Occurred While uploading file", {
  //       variant: "error",
  //     });
  //     console.error(
  //       "Error uploading file:",
  //       error.response?.data?.error || error.message
  //     );
  //   }
  // };



  useEffect(() => {
    if (FollowupDate && LeadDate) {
      const lead = new Date(LeadDate);
      const followup = new Date(FollowupDate);

      if (followup < lead) {
        enqueueSnackbar("Followup date must be after lead date.", {
          variant: "error",
        });
        setFollowupDate(null);
      }
    }
  }, [FollowupDate, LeadDate, enqueueSnackbar]);

  // const auth = localStorage.getItem("auth");
  const { iso2: defaultCountry, onlyCountries: allowedCountries } =
    resolveCountryInputConfig({
      countrycode: loggedUser?.countrycode,
      region: loggedUser?.region,
    });


  // useEffect(() => {
  //   const Group = AssignedGroup.charAt(0).toUpperCase()
  //   const ClientNameCapitalized = ClientName.charAt(0).toUpperCase()
  //   const ProjectNameCapitalized = ProjectName.charAt(0).toUpperCase()
  //   let LeadID = ""
  //   if (ProjectNameCapitalized) {
  //     LeadID = `${Group}${ClientNameCapitalized}${ProjectNameCapitalized}000001`
  //   }
  //   setQuotationId(LeadID)
  // }, [employees, AssignedGroup, ClientName, ProjectName])

  const handleNext = (response) => {
    if (operationProjectStatus === "response received" && !existingEditAdvancedProject) {
      const status = response?.Status?.toLowerCase()?.trim();
      console.log("EditExistingProject response", response)

      if (status !== "won") {
        navigate('/dashboard');
        dispatch(clearWizardState())
        dispatch(setcurrentLeadID(""))
      } else {
        setTimeout(() => {
          dispatch(goNext())
        }, 2000);
      }

    } else {
      // In ERP module: If status is "won" or "won recurring", end wizard and go to dashboard (skip Project Approved)
      // Check both the response status and the current form status
      const responseStatus = response?.Status?.toLowerCase()?.trim() || "";
      const formStatus = Status?.toLowerCase()?.trim() || "";
      const statusToCheck = responseStatus || formStatus;
      const isWon = statusToCheck === "won" || statusToCheck === "won recurring";
      
      console.log("EditExistingProject handleNext - ERP check:", {
        subscriptionPackage,
        wizardPlanState,
        wizardProjectState,
        responseStatus,
        formStatus,
        isWon,
        step
      });
      
      // If Won status in ERP, this should have been handled in Submit function already
      // But keep this as a safety check
      if (subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" && isWon) {
        // End wizard and go to dashboard - do not show Project Approved window
        console.log("EditExistingProject handleNext - Ending wizard and redirecting to dashboard (Won status)");
        dispatch(clearWizardState());
        dispatch(setcurrentLeadID(""));
        navigate('/dashboard');
        return;
      }
      
      dispatch(setExistingEditAdvancedProject(false))
      
      // In ERP module: Before navigating, ensure the correct status is set based on SalesStatus
      // This ensures that when clicking Next from Existing Project, it goes to the correct page
      if (subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
        // Use SalesStatus as the source of truth - prioritize it over operationProjectStatus
        // This is critical for correct navigation when going back and forth
        const statusToSet = SalesStatus || operationProjectStatus || "project requested";
        
        // Always set the status before navigating to ensure correct routing
        dispatch(setOperationProjectStatus(statusToSet));
        dispatch(setCreatedProject(createdProject));
        
        // Small delay to ensure state is updated before navigation
        setTimeout(() => {
          if (step === Number(4)) {
            dispatch(resetStep())
          } else if (step === Number(2)) {
            dispatch(goBack())
          } else {
            dispatch(goNext())
          }
        }, 100);
        return; // Exit early to prevent double navigation
      }
      
      if (step === Number(4)) {
        dispatch(resetStep())
      } else if (step === Number(2)) {
        dispatch(goBack())
        // dispatch(resetStep())
      } else {
        dispatch(goNext())
      }
    }
  }

  return (
    <div className=" bg-[#f3f8f8] h-full pt-2">
      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (
        <>
          <div className="relative justify-center bg-white rounded-md ">
            <div className="rounded-md p-2 pb-10">
              <div
                className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {/* Lead Date */}
                <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="date">
                    Lead
                    <span className="text-red-700 text-xl">*</span>
                  </label>

                  <DatePicker
                    wrapperClassName="w-full"
                    selected={LeadDate}
                    onChange={(date) => setLeadDate(date)}
                    onChangeRaw={(e) => {
                      const inputValue = e.target.value;
                      if (!inputValue || inputValue.length < 10) return;
                      const [month, day, year] = inputValue.split("-");
                      const parsedDate = new Date(`${year}-${month}-${day}`);
                      if (parsedDate instanceof Date && !isNaN(parsedDate)) {
                        // Check if date is not in future
                        if (parsedDate <= new Date()) {
                          setLeadDate(parsedDate);
                        }
                      }
                    }}
                    dateFormat={getDateFormat()}
                    className="border w-full mr-14 pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    placeholderText={getDatePlaceholder()}
                    maxDate={new Date()} // Disable future dates
                    required
                    customInput={
                      <InputMask
                        mask="99-99-9999"
                        placeholder={getDatePlaceholder()}
                        className="border w-full pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      />
                    }
                  />
                </div>

                {/* Group */}
                <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Source">
                    Group<span className="text-red-700 text-xl">*</span>
                  </label>
                  <div className="w-full ">
                    <div
                      ref={dropdownRefGroup}
                      className="relative flex w-full  p-0 rounded-xl align-middle items-center"
                    >
                      <ExpandMoreIcon
                        color="white"
                        className="absolute cursor-pointer right-0 border-r border-gray-400 m-auto bg-white"
                        onClick={() => setShowGroupDropdown(!showGroupDropdown)}
                      />

                      <button
                        type="button"
                        onClick={() => setShowGroupDropdown(!showGroupDropdown)}
                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                      >
                        {AssignedGroup ? AssignedGroup : <p>Select Group</p>}
                      </button>

                      {showGroupDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          {GroupNames.map((group) => (
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() => {
                                handleGroupChange(group.newGroupName)
                                setSelectedServices([]); // Reset selected services when group changes
                              }}
                              key={group.id}
                              value={group.newGroupName}
                            >
                              {group.newGroupName}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Client Name */}
                <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Name">
                    Client Name<span className="text-red-700 text-xl">*</span>
                  </label>
                  <input
                    className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    type="text"
                    placeholder="Enter Name"
                    value={ClientName}
                    maxLength={30}
                    onChange={(e) => {
                      let value = e.target.value;
                      const filteredValue = value.replace(
                        /[^a-zA-Z0-9!@#$%*_\s-]/g,
                        ""
                      );
                      setClientName(filteredValue);
                    }}
                  />
                </div>

                {/* Project Name */}
                <div
                  className="pt-1 mb-4"
                  style={{ width: "22%", height: "4%" }}
                >
                  <label className="block" htmlFor="Name">
                    Project Name<span className="text-red-700 text-xl">*</span>
                  </label>
                  <input
                    className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    type="text"
                    placeholder="Enter Project Name"
                    disabled={allowtoedit?.length > 0}
                    maxLength={30}
                    value={ProjectName}
                    onChange={(e) => {
                      let value = e.target.value;
                      const filteredValue = value.replace(
                        /[^a-zA-Z0-9!@#$%*_\s-]/g,
                        ""
                      );
                      setProjectName(filteredValue);
                    }}
                  />
                </div>


              </div>

              <div
                className="grid grid-cols-1 md:grid-cols-4 gap-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >


                {/* Type of Service */}
                <div
                  className="pt-1 mb-4"
                  style={{ width: "22%", height: "4%" }}
                >
                  <label className="block" htmlFor="Source">
                    Type of Service
                    <span className="text-red-700 text-xl">*</span>
                  </label>
                  <div className=" bg-white">
                    <div
                      ref={dropdownRefService}
                      className="relative flex  p-0  rounded-xl align-middle items-center"
                    >
                      <ExpandMoreIcon
                        color="white"
                        className="absolute cursor-pointer right-2 m-auto bg-white"
                        onClick={() =>
                          setShowServiceDropdown(!showServiceDropdown)
                        }
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setShowServiceDropdown(!showServiceDropdown)
                        }
                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none"
                      >
                        {serviceTypes.length === 0 ? (
                          <span className="text-black">
                            No Service Type
                          </span>
                        ) : TypeService.length > 0 ? (
                          <div className="flex overflow-hidden gap-1">
                            {TypeService.map((service) => (
                              <span
                                key={service}
                                className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs"
                              >
                                {service}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="">Select Service Type</span>
                        )}
                      </button>

                      {showServiceDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          {serviceTypes.map((serviceType) => {
                            const isSelected = TypeService.includes(
                              serviceType
                            );
                            return (
                              <div
                                key={serviceType}
                                className={`p-1 cursor-pointer ${isSelected
                                  ? "bg-blue-100 font-semibold"
                                  : "hover:bg-gray-200"
                                  }`}
                                onClick={() =>
                                  handleServiceChange(serviceType)
                                }
                              >
                                {serviceType}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="pt-1 mb-4"
                  style={{ width: "22%", height: "4%" }}
                >
                  <label className="block" htmlFor="Name">
                    Quoted Value<span className="text-red-700 text-xl">*</span> ({currency})
                  </label>
                  <input
                    className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    type="text"
                    placeholder="Enter Quoted Value"
                    inputMode="numeric"
                    maxLength={14}
                    pattern="[0-9]*"
                    value={USAComma(QuotedValue)}
                    onChange={(e) =>
                      setQuotedValue(
                        e.target.value.replace(/,/g, "").replace(/\D/g, "")
                      )
                    }
                  />
                </div>

                {/* Source */}
                <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Source">
                    Source<span className="text-red-700 text-xl">*</span>
                  </label>
                  <div className=" bg-white">
                    <div
                      ref={dropdownRefSource}
                      className="relative flex  p-0  rounded-xl align-middle items-center"
                    >
                      <ExpandMoreIcon
                        color="white"
                        className="absolute cursor-pointer right-2 m-auto"
                        onClick={() =>
                          setShowSourceDropdown(!showSourceDropdown)
                        }
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setShowSourceDropdown(!showSourceDropdown)
                        }
                        className="border w-full bg-white border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                      >
                        {Source ? Source : <p>Select Source</p>}
                      </button>

                      {showSourceDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          {Sources.map((Sourc) => (
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() =>
                                handleSourceChange(Sourc.newSource)
                              }
                              key={Sourc.id}
                              value={Sourc.newSource}
                            >
                              {Sourc.newSource}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Reference */}
                <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Name">
                    Reference
                    {Source === "Reference" ? (
                      <span className="text-red-700 text-xl">*</span>
                    ) : (
                      <span className="text-red-700 text-xl"></span>
                    )}
                  </label>
                  <input
                    className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${Source !== "Reference" ? "bg-gray-200" : ""
                      }`}
                    type="text"
                    maxLength={30}
                    placeholder="Enter Reference"
                    value={Source === "Reference" ? Reference : ""}
                    onChange={(e) => {
                      let value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allows only letters and spaces
                      value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalizes the first letter
                      setReference(value);
                    }}
                    disabled={Source !== "Reference"}
                  />
                </div>
              </div>

              <div
                className="grid grid-cols-1 md:grid-cols-4 gap-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Name">
                    Contact Person
                    <span className="text-red-700 text-xl">*</span>
                  </label>
                  <input
                    className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    type="text"
                    placeholder="Enter Name"
                    maxLength={30}
                    value={ClientContactName}
                    onChange={(e) => {
                      let value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allows only letters and spaces
                      value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalizes the first letter
                      setClientContactName(value);
                    }}
                  />
                </div>

                <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="email">
                    Email ID<span className="text-red-700 text-xl">*</span>
                  </label>
                  <input
                    className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    type="text"
                    placeholder="Enter Email ID"
                    value={ClientEmail}
                    onChange={(e) => setClientEmail(e.target.value)}
                  />
                </div>

                <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Name">
                    Mobile Number<span className="text-red-700 text-xl">*</span>
                  </label>
                  <PhoneInput
                    country={defaultCountry}
                    countryCodeEditable={false}   // 🔴 THIS IS THE FIX
                    disableDropdown={true}
                    value={String(ClientPhone)}
                    onChange={(value) => setClientPhone(value)}
                    onlyCountries={allowedCountries}
                    preferredCountries={[]}       // <-- Required to remove default countries
                    enableSearch={true}
                    inputProps={{
                      required: true,
                      className:
                        "w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10",
                      style: {
                        fontFamily:
                          "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                      },
                    }}
                  />
                </div>

                <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Source">
                    Lead Type<span className="text-red-700 text-xl">*</span>
                  </label>
                  <div className=" bg-white">
                    <div
                      ref={dropdownRefLeadType}
                      className="relative flex  p-0  rounded-xl align-middle items-center"
                    >
                      <ExpandMoreIcon
                        color="white"
                        className="absolute cursor-pointer right-2 m-auto bg-white"
                        onClick={() =>
                          setShowLeadTypeDropdown(!showLeadTypeDropdown)
                        }
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setShowLeadTypeDropdown(!showLeadTypeDropdown)
                        }
                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                      >
                        {LeadType ? LeadType : <p>Select Lead Type</p>}
                      </button>

                      {showLeadTypeDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          {LeadTypes.map((LeadTyp) => (
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() =>
                                handleLeadTypeChange(LeadTyp.LeadType)
                              }
                              key={LeadTyp.id}
                              value={LeadTyp.LeadType}
                            >
                              {LeadTyp.LeadType}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="grid grid-cols-1 md:grid-cols-4 gap-4"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {/* Status */}
                <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Status">
                    Status<span className="text-red-700 text-xl">*</span>
                  </label>
                  <div className=" bg-white">
                    <div
                      ref={dropdownRefStatus}
                      className="relative flex  p-0  rounded-xl align-middle items-center"
                    >

                      <ExpandMoreIcon
                        color="white"
                        className={`absolute right-2 m-auto bg-white 
                         ${editingLeadReport?.Status === "Won" || editingLeadReport?.Status === "won"
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"}`}

                        onClick={() => {
                          if (editingLeadReport?.Status === "Won" || editingLeadReport?.Status === "won") return;
                          setShowStatusDropdown(!showStatusDropdown);
                        }}
                      />


                      <button
                        disabled={editingLeadReport?.Status === "Won" || editingLeadReport?.Status === "won"}
                        type="button"
                        onClick={() =>
                          setShowStatusDropdown(!showStatusDropdown)
                        }
                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                      >
                        {Status ? Status : <p>Select Status</p>}
                      </button>

                      {showStatusDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          {statuses.filter((s) =>
                            editingLeadReport?.Status?.toLowerCase() === "won recurring"
                              ? s.status === "Won"        // show only Won
                              : true                      // otherwise show all
                          )
                            .map((statuse) => (
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() => handleStatusChange(statuse.status)}
                                key={statuse.id}
                                value={statuse.status}
                              >
                                {statuse.status}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Probability */}
                <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                  <label className="block" htmlFor="Status">
                    Probability{" "}
                    {Status === "Pending" ? (
                      <span className="text-red-700 text-xl">*</span>
                    ) : (
                      <span className="text-red-700 text-xl"></span>
                    )}
                  </label>
                  <div className=" bg-white">
                    <div
                      ref={dropdownRefProbability}
                      className="relative flex  p-0  rounded-xl align-middle items-center"
                    >
                      <ExpandMoreIcon
                        color="white"
                        className={`absolute right-2 m-auto 
                          ${Status !== "Pending" ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}
                        onClick={() => {
                          if (Status === "Pending") {
                            setShowProbabilityDropdown(!showProbabilityDropdown);
                          }
                        }}
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setShowProbabilityDropdown(!showProbabilityDropdown)
                        }
                        disabled={Status !== "Pending"} // Disable when Status is not "Pending"
                        className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none ${Status !== "Pending" ? "bg-gray-200" : ""
                          }`}

                      >
                        {Probability ? Probability : <p>Select Probability</p>}
                      </button>

                      {showProbabilityDropdown && (
                        <div
                          style={{ zIndex: 9999 }}
                          className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                        >
                          <div
                            className="p-1 hover:bg-gray-200 cursor-pointer"
                            onClick={() => handleProbabilityChange("High")}
                          >
                            High
                          </div>
                          <div
                            className="p-1 hover:bg-gray-200 cursor-pointer"
                            onClick={() => handleProbabilityChange("Medium")}
                          >
                            Medium
                          </div>
                          <div
                            className="p-1 hover:bg-gray-200 cursor-pointer"
                            onClick={() => handleProbabilityChange("Low")}
                          >
                            Low
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="pt-1" style={{ width: "22.5%", height: "4%" }}>
                  <label className="block " htmlFor="date">
                    {Status === "Won" || Status === "Lost" ? (
                      ""
                    ) : (
                      <>
                        {" "}
                        Next Follow-up Date
                        <span className="text-red-700 text-xl">*</span>
                      </>
                    )}
                  </label>
                  {Status !== "Won" && Status !== "Lost" && (
                    <DatePicker
                      selected={FollowupDate}
                      onChange={(date) => setFollowupDate(date)}
                      dateFormat={getDateFormat()}
                      placeholderText={getDatePlaceholder()}
                      minDate={
                        LeadDate
                          ? new Date(
                            new Date(LeadDate).setDate(
                              new Date(LeadDate).getDate() + 1
                            )
                          )
                          : null
                      }
                      customInput={
                        <InputMask
                          mask="99-99-9999"
                          placeholder={getDatePlaceholder()}
                          className="border w-full pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                        />
                      }
                      onChangeRaw={(e) => {
                        const inputValue = e.target.value;
                        if (!inputValue || inputValue.length < 10) return;

                        const [month, day, year] = inputValue.split("-");
                        const parsedDate = new Date(`${year}-${month}-${day}`);
                        if (parsedDate instanceof Date && !isNaN(parsedDate)) {
                          setFollowupDate(parsedDate);
                        }
                      }}
                    />
                  )}
                </div>

                <div className="pt-1 flex gap-2" style={{ width: "22%", height: "4%" }}>
                  <FileUploadAddLead
                    setFileNames={setFileNames}
                    fileNames={[...fileNames, ...(editfetchedfiles?.payload || [])]}
                    SelectedCategory={SelectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    projectName={ProjectName}
                  />

                  {/* {packageData === "CRM" && (
                      <div title="Generate Quote" className="flex flex-col justify-end pb-3">
                        {auth === "L3" && ProjectName && (
                          <TextSnippetIcon className="w-5 h-5 cursor-pointer"
                            onClick={() => {
                              setShowQuoteModal(true);
                              setselectedProject(ProjectName)
                              setselectedGroup(ProjectName)
                            }} />
                        )}
                      </div>
                    )} */}

                </div>
              </div>
              <br></br>

              <div className="w-full flex">
                <div className="w-1/2 pr-5 ">
                  <label className="block" htmlFor="comments">
                    Comments
                  </label>
                  <textarea
                    className="border w-full border-gray-400 rounded-md p-4 overflow-hidden shadow-md outline-none resize-none"
                    placeholder="Enter Comments"
                    id="comments"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    required={Status === "Pending"}
                    name="comments"
                    rows={2}
                  />
                </div>
                <div className="w-1/2 flex justify-end items-end">
                  <div className=" flex justify-end gap-4 h-10">
                    <button
                      onClick={() => {
                        dispatch(setcurrentLeadID(""));
                        dispatch(goBack())
                      }}
                      className=" py-2 px-7 bg-black overflow-hidden shadow-md text-white rounded-lg"
                    >
                      Back
                    </button>
                    <button
                      onClick={() => {
                        Submit()
                      }}
                      className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
                    >
                      {operationProjectStatus === "response received" ? "Save" : "Next"}
                    </button>
                  </div>
                </div>
              </div>
              {/* 
                <div className="flex mt-8 gap-5 justify-start">
                  <button
                    onClick={Submit}
                    className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
                  >
                    Confirm
                  </button>
                  <button
                    onClick={Cancel}
                    className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg"
                  >
                    Cancel
                  </button>
                </div> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditExistingProject;
